import React, { useState } from 'react';
import check from '../../images/track-icon/check.png';
import bookedIcon from '../../images/track-icon/booked.svg';
import status01 from '../../images/track-icon/manifested.svg';
import status02 from '../../images/track-icon/picked.svg';
import status03 from '../../images/track-icon/in-transit.svg';
import status04 from '../../images/track-icon/ofd.svg';
import status05 from '../../images/track-icon/deliverd.svg';
import status06 from '../../images/track-icon/ndr.svg';
import status07 from '../../images/track-icon/wrong-parcel.png';
import status08 from '../../images/track-icon/Lost.svg';
import line from '../../images/track-icon/line.png';
import { Icon } from '@iconify/react';
import review_box from '../../images/track-icon/delivery-box.png'
import RatingComponent from '../RatingComponent';
import location_Img from '../../images/icon/location.png'

function TrackingHistory({ data }) {
  const [showTable, setShowTable] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [rating, setRating] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const shipment = data?.data?.[0];
  if (!shipment) return <p>Loading...</p>;
  const isReverse = shipment?.shipment_type === "reverse";
  const forwardStatusMap = {
    RTS: "Returned to Source",
    RTO: "Returning to Origin",
    NDR: "NDR",
    OFD: "Out for Delivery",
    DEL: "Delivered",
    INT: "In-Transit",
    PKD: "Picked",
    MAN: "Manifested",
    BOK: "Booked"
  };

  const reverseStatusMap = {
    "RVP NPR": "NPR",
    "RVP IN TRANSIT": "In-Transit",
    "RVP NDR": "NDR",
    "RVP OFD": "Out for Delivery",
    "RVP DTO": "DTO"
  };

let currentStatus = "Booked";

if (isReverse) {
   
  if (shipment?.delivered_date) {
    currentStatus = "DTO";
  }
  else if (shipment?.rvp_dto_faild) {
    currentStatus = "DTO Failed";
  }
  else if (shipment?.rvp_ofd) {
    currentStatus = "Out for Delivery";
  }
  else if (shipment?.rvp_ndr_log?.length) {
    currentStatus = "NDR";
  }
  else if (shipment?.rvp_in_transit) {
    currentStatus = "In-Transit";
  }
  else if (shipment?.rvp_picked_date) {
    currentStatus = "Picked";
  }
  else if (shipment?.rvp_npr_date) {
    currentStatus = "NPR";
  }
} else {
    
  if (shipment?.current_status === "Cancelled") currentStatus = "Cancelled";
  else if (shipment?.current_status === "RTS" || shipment?.rts_date) {
  currentStatus = "Returned to Source";
}
  else if (
  shipment?.current_status?.toLowerCase().includes("rto") ||
  shipment?.rto_date
) {
  currentStatus = "Returning to Origin";
}
  else if (shipment?.delivered_date) currentStatus = "Delivered";
  else if (shipment?.ndr_log?.length) currentStatus = "NDR";
  else if (shipment?.ofd_date) currentStatus = "Out for Delivery";
  else if (shipment?.in_transit_date) currentStatus = "In-Transit";
  else if (shipment?.pickup_date) currentStatus = "Picked";
  else if (shipment?.manifested_date) currentStatus = "Manifested";

}
  const clickableStatuses = isReverse ? ["In-Transit", "NDR", "NPR"]: ["In-Transit", "NDR", "Returning to Origin", "Returned to Source"];;

  const baseStatuses = isReverse
  ? [
      { status: "Booked", date: shipment?.booked_date },
      { status: "NPR", date: shipment?.rvp_npr_date },
      { status: "Picked", date: shipment?.rvp_picked_date },
      { status: "In-Transit", date: shipment?.rvp_in_transit },
      ...(shipment?.rvp_ndr_log?.length
        ? [{
            status: "NDR",
            date: shipment?.rvp_ndr_log?.slice(-1)[0]?.scanned_at
          }]
        : []),
      { status: "Out for Delivery", date: shipment?.rvp_ofd },
    ]
  : [
      { status: "Booked", date: shipment?.booked_date },
      { status: "Manifested", date: shipment?.manifested_date },
      { status: "Picked", date: shipment?.pickup_date },
      { status: "In-Transit", date: shipment?.in_transit_date },
      { status: "Out for Delivery", date: shipment?.ofd_date }
    ];
    let reverseStatuses = [
      { status: "Booked", date: shipment?.booked_date },

      { status: "NPR", date: shipment?.rvp_npr_date },

      { status: "In-Transit", date: shipment?.rvp_in_transit },

      {
        status: "NDR",
        date: shipment?.rvp_ndr_log?.slice(-1)[0]?.scanned_at
      },

      { status: "Out for Delivery", date: shipment?.rvp_ofd }
    ];
  const ndrStep =
    shipment?.ndr_log?.length > 0
      ? [{
          status: "NDR",
          date: shipment?.ndr_log?.slice(-1)[0]?.scanned_at || null
        }]
      : [];

  let finalStep = null;
    // if (shipment?.rvp_dto_faild) {
    //   finalStep = {
    //     status: "Delivered",
    //     date: shipment?.rvp_dto_faild
    //   };
    // }
    if (isReverse) {
      if (shipment?.delivered_date) {
        finalStep = {
          status: "DTO",
          date: shipment?.delivered_date
        };
      } else if (shipment?.rvp_dto_faild) {
        finalStep = {
          status: "DTO Failed",
          date: shipment?.rvp_dto_faild
        };
      }
    }else {
      if (shipment?.rts_date) {
    finalStep = {
      status: "Returned to Source",
      date: shipment?.rts_date
    };
  } 
  
  else if (shipment?.current_status === "RTS") {
    finalStep = {
      status: "Returned to Source",
      date:
        shipment?.rto_log?.slice(-1)[0]?.scanned_at ||
        shipment?.rto_date ||
        null
    };
  }  
  else if (
  shipment?.rto_date ||
  shipment?.current_status === "RTO-Pending"
) {
  finalStep = {
    status: "Returning to Origin",
    date:
      shipment?.rto_date ||
      shipment?.rto_log?.slice(-1)[0]?.scanned_at ||
      null
  };
}
  else {
    finalStep = {
      status: "Delivered",
      date: shipment?.delivered_date || null
    };
  }
}


  let finalTrackingData = [
  ...baseStatuses,
  ...ndrStep,
  finalStep
];

const lastIndex = finalTrackingData.reduce((acc, item, index) => {
  return item?.date ? index : acc;
}, -1);


if (shipment?.current_status === "Cancelled") {

  const cancelDate =
    shipment?.cancelled_date ||
    shipment?.ndr_log?.slice(-1)[0]?.scanned_at ||
    shipment?.in_transit_log?.slice(-1)[0]?.scanned_at ||
    shipment?.pickup_date ||
    shipment?.manifested_date ||
    shipment?.booked_date;

  finalTrackingData = finalTrackingData.filter(
    item => item.status !== "Delivered"
  );

  const lastIndex = finalTrackingData.reduce((acc, item, index) => {
  return item?.date ? index : acc;
}, -1);

  finalTrackingData.splice(lastIndex + 1, 0, {
    status: "Cancelled",
    date: cancelDate
  });
}
if (shipment?.lost_date) {
  const lostStep = {
    status: "Lost",
    date: shipment.lost_date
  };

  const lastValidIndex = finalTrackingData.reduce((acc, item, index) => {
    return item?.date ? index : acc;
  }, -1);

  finalTrackingData.splice(lastValidIndex + 1, 0, lostStep);
}
finalTrackingData = finalTrackingData.filter(item => {
  const status = shipment?.current_status?.toLowerCase() || "";

  if (
    (status.includes("rto") || status.includes("rts") || shipment?.rto_date || shipment?.rts_date) &&
    item.status === "Delivered"
  ) {
    return false;
  }

  return true;
});
  const formattedData = finalTrackingData.map(item => {
    if (!item || !item?.date) {
        return {
        ...item,
        date: "",
        time: ""
        };
    }
    const clean = item?.date
        .replace(/\n/g, " ")     
        .replace(/\s+/g, " ")    
        .trim();

    const normalized = clean.replace(/,(\d{2})/, ", $1");

    const dateMatch = normalized.match(/\d{1,2}\s\w{3},\s\d{2}/);
    const timeMatch = normalized.match(/\d{1,2}:\d{2}\s?(AM|PM)/i);

    return {
        ...item,
        date: dateMatch ? dateMatch[0] : "",
        time: timeMatch ? timeMatch[0].replace(" ", "\u00A0") : ""
    };
    });
    let currentIndex = formattedData.findIndex(item => {
  const itemStatus = item?.status?.toLowerCase()?.replace(/\s+/g, "-") || "";
  const currStatus = currentStatus?.toLowerCase()?.replace(/\s+/g, "-") || "";

  if (currStatus === "returned-to-source") {
    return itemStatus === "returned-to-source" || itemStatus === "returning-to-origin";
  }

  return itemStatus.includes(currStatus) || currStatus.includes(itemStatus);
});
if (shipment?.lost_date) {
  currentIndex = formattedData.findIndex(item => item.status === "Lost");
}
if (currentIndex === -1) {
  currentIndex = formattedData.length - 1;
}
  const formatLogs = (logs = [], title) => {
    if (!logs || logs.length === 0) return null;

    const grouped = {};

    logs.forEach(item => {
      const clean = item.scanned_at
        .replace(/\n/g, " ")
        .replace(/\s+/g, " ")
        .trim();

      const normalized = clean.replace(/,(\d{2})/, ", $1");

      const dateMatch = normalized.match(/\d{1,2}\s\w{3},\s?\d{2}/);
      const timeMatch = normalized.match(/\d{1,2}:\d{2}\s?(AM|PM)/i);

      const date = dateMatch ? dateMatch[0] : "";
      const time = timeMatch ? timeMatch[0].replace(" ", "\u00A0") : "";

      if (!grouped[date]) grouped[date] = [];

      grouped[date].push({
        time,
        remark: item.remark,
        location: item.location
      });
    });

    return {
      title,
      data: Object.keys(grouped).map(date => ({
        date,
        logs: grouped[date]
      }))
    };
  };

  const logsData = {
  "In-Transit": formatLogs(
    isReverse ? shipment?.rvp_in_transit_log : shipment?.in_transit_log,
    "In-Transit Logs"
  ),
  "NDR": formatLogs(
    isReverse ? shipment?.rvp_ndr_log : shipment?.ndr_log,
    "NDR Logs"
  ),
  "NPR": formatLogs(
    shipment?.rvp_npr_log,
    "Pickup Request Logs"
  ),
  "Returning to Origin": formatLogs(
    shipment?.rto_log,
    "RTO Logs"
  ),
  "Returned to Source": formatLogs(
    shipment?.rto_log,
    "RTO Logs"
  )
};
  const lastActivity = isReverse
  ? shipment?.rvp_ndr_log?.slice(-1)[0] ||
    shipment?.rvp_in_transit_log?.slice(-1)[0] ||
    shipment?.rvp_npr_log?.slice(-1)[0]
  : shipment?.rto_log?.slice(-1)[0] ||
    shipment?.ndr_log?.slice(-1)[0] ||
    shipment?.in_transit_log?.slice(-1)[0];

  const statusStyles = {
  "Not Picked": { bg: "#FF660015", color: "#FF6600" },
  "Booked": { bg: "#FF660015", color: "#FF6600" },
  "Manifested": { bg: "#16478310", color: "#164783" },
  "Picked": { bg: "#6155F510", color: "#6155F5" },
  "Pickup Pending": { bg: "#6155F510", color: "#6155F5" },
  "In-Transit": { bg: "#FFDB4310", color: "#DFB400" },
  "In Transit": { bg: "#FFDB4310", color: "#DFB400" },
  "RTO-Dispatched": { bg: "#FFDB4310", color: "#DFB400" },
  "Out for Delivery": { bg: "#0088FF10", color: "#0088FF" },
  "Out For Pickup": { bg: "#0088FF10", color: "#0088FF" },
  "Dispatched": { bg: "#66BB1820", color: "#66BB18" },
  "NDR": { bg: "#0088FF10", color: "#0088FF" },
  "Delivered": { bg: "#1FC16B10", color: "#1FC16B" },
  "Returning to Origin": { bg: "#D0041610", color: "#D00416" },
  "Returned to Source": { bg: "#D0041610", color: "#D00416" },
  "Cancelled": { bg: "#D0041610", color: "#D00416" },
  "RTS": { bg: "#D0041610", color: "#D00416" },
  "RTO-IT": { bg: "#FFDB4310", color: "#DFB400" },
  "RTO-Pending": { bg: "#FFDB4310", color: "#DFB400" },
  "RTO": { bg: "#D0041610", color: "#D00416" },
  "DTO REJECTED": { bg: "#D0041610", color: "#D00416" },
  "LOST": { bg: "#D0041610", color: "#D00416" }
};
  const status = currentStatus;

    const style = statusStyles[status] || {
      bg: "#eee",
      color: "#333"
    };
  const activeIcons = {
    "Booked": bookedIcon,
    "Manifested": status01,
    "Picked": status02,
    "In-Transit": status03,
    "Out for Delivery": status04,
    "NDR": status06,
    "NPR": status06,
    "Delivered": status05,
    "Returning to Origin": status06,
    "Returned to Source": status06,
    "DTO":status05,
    "DTO Failed":status07,
    "Cancelled":status07,
    "Lost":status08,
  };

  const getIcon = (status, index) => {
  if (index < currentIndex) return check;

  return activeIcons[status] || status;
};

  const shortStatusMap = {
    "Returning to Origin": "RTO",
    "Returned to Source": "RTS"
  };

  const getDefaultLogStatus = () => {
    if (shipment?.rto_log?.length) return "Returning to Origin";
    if (shipment?.ndr_log?.length) return "NDR";
    if (shipment?.in_transit_log?.length) return "In-Transit";
    return null;
  };
  const rawStatus = shipment?.current_status || "Booked";

    let displayStatus = rawStatus;

    if (shipment?.rts_date) {
      displayStatus = "Returned to Source";
    } else if (rawStatus === "RTO") {
      displayStatus = "Returning to Origin";
    }
  const submitRating = async () => {
    if (!rating) return alert("Please select rating");

    try {
      const res = await fetch("/api/save-rating", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          awb: shipment?.awb_number,
          rating: rating
        })
      });

      const data = await res.json();
      console.log("Saved:", data);

      setSubmitted(true); 

    } catch (err) {
      console.error(err);
    }
  };
  const waybills = shipment?.child_waybill?.split(",") || [];
  return (
    <div className="section-02">
      <div className='container-fluid'>
        <div className="col-md-11 mx-auto">
          <div className='row'>
            <div className="col-xl-4 mb-3">
              <div className="tracking-card information mb-4">
                <div className="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
                  <div>
                    <p>Tracking ID</p>
                    <h6 className='mb-0'>{shipment?.awb_number} 
                      {shipment?.child_waybill && (
                        <span className="child-awb"  onClick={() => setShowModal(true)}>
                          View Child AWB
                        </span>
                      )}
                    </h6>
                  </div>
                  <img src={shipment?.partner_display_logo} height="45" alt={shipment?.partner_display_name || "Courier"} />
                </div>
                <div className=''>
                  <p> {shipment?.current_status?.toLowerCase() === "delivered" ? "Delivered On" : shipment?.estimated_delivery_date ? "Estimated Delivery Date" : "Current Status"}</p>
                  <h3> {shipment?.delivered_date ? shipment?.delivered_date : shipment?.estimated_delivery_date || ""}</h3>

                  <div className="shipment-status"
                    style={{
                      backgroundColor: statusStyles[rawStatus]?.bg,
                      color: statusStyles[rawStatus]?.color
                    }}>
                    <span style={{ backgroundColor: statusStyles[rawStatus]?.color }}></span>
                    {rawStatus}
                  </div> 
                </div>
                {(shipment?.consignee_pincode || shipment?.consignee_city) && (
                  <div className='location-box'>
                    <img src={location_Img} height={20} />
                    <h6 className='mb-0'>
                      <span className='text-gray me-1'>Delivery Destination: </span>
                      {[shipment?.consignee_pincode, shipment?.consignee_city]
                        .filter(Boolean)
                        .join(', ')}
                    </h6>
                  </div>
                )}
                {/* <p className='mb-0 mt-3 f-14'>{shipment?.status_remark}</p> */}
              </div>
              {/* {shipment?.delivered_date && (
                <div className='rate-shipment-card'> 
                  <div className='rate-shipment-content'> 
                    <p className='f-20 fw-500 mb-2'>Rate your shipping experience</p> 
                    <p className='f-12 mb-0'>
                      Sharing your feedback will help us  continuously improve<br /> & serve you better.
                    </p> 
                    <RatingComponent/>
                    <img src={review_box} className='review-img' />
                  </div> 
                </div>
              )} */}
            </div>
            <div className="col-xl-8 mb-3">
              <div className="tracking-card">
                <div className='tracking-card'>
                  <p className='f-18 fw-600 mb-2'>Recent Activity </p>
                  <p className='mb-0 last-update-text'>
                    <b>Last Update: </b>
                    {shipment?.recent_activity 
                      || lastActivity?.remark 
                      || "No Updates"}

                    <span className="text-gray ms-3">
                      {shipment?.recent_activity_date 
                        || lastActivity?.scanned_at 
                        || ""}
                    </span>
                    {/* {lastActivity?.recent_activity || "No Updates"}
                    <span className="text-gray ms-3"> {lastActivity?.recent_activity_date}</span> */}
                  </p>
                </div>
                <div className="track-history history-item-n">
                  {formattedData.map((item, index) => (
                    <>
                      <div key={index} className={`history-items ${index < currentIndex ? "completed" : ""} ${index === currentIndex ? "active" : ""}`}>
                        <div className='date'>
                          <h4>{item?.date}</h4>
                          <p>{item.time}</p>
                        </div>
                        <div className='icon'>
                          <img src={getIcon(item.status, index)} alt="" className={`d-block logo-img ${ index <= currentIndex ? "opacity-100" : "opacity-50" }`} />
                          {index !== formattedData.length - 1 && <img src={line} className={`d-block line-img ${ index <= currentIndex ? "opacity-100" : "opacity-50" }`} alt="" />}
                        </div>
                        <div>
                          <h6>
                              {shipment?.rts_date && item.status === "Returning to Origin"
                            ? "Returned to Source"
                            : shortStatusMap[item.status] || item.status}
                            {/* {shortStatusMap[item.status === "Returned to Source" ? "Returning to Origin" : item.status] 
                              || (item.status === "Returned to Source" ? "Returning to Origin" : item.status)} */}
                            {clickableStatuses.includes(item.status) &&
                              logsData[item.status]?.data?.length > 0 && (
                              <span className={`tracking-icon ${ selectedStatus === item.status ? "show" : "" }`}
                                style={{ cursor: "pointer", marginLeft: "6px" }}
                                onClick={() => {
                                  if (selectedStatus === item.status) {
                                    setSelectedStatus(null);
                                    setShowTable(false);
                                  } else {
                                    setSelectedStatus(item.status);
                                    setShowTable(true);
                                  }
                                }}
                              >
                                <Icon icon="material-symbols:info-outline" />
                              </span>
                            )}
                          </h6>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
                <div className="track-history history-item-b">
                  {formattedData.map((item, index) => (
                    <div key={index}>
                      <div key={index} className={`history-items  ${index < currentIndex ? "completed" : ""} ${index === currentIndex ? "active" : ""}`}>
                        <div className='icon-date'>
                          <div className='icon'>
                            <img src={getIcon(item.status, index)} alt="" className={`d-block logo-img ${ index <= currentIndex ? "opacity-100" : "opacity-50" } ${index === formattedData.length - 1 ? "last-line" : ""}`} />
                            {index !== formattedData.length - 1 && <img src={line} className={`d-block line-img ${ index <= currentIndex ? "opacity-100" : "opacity-50" } `} alt="" />}
                          </div>
                          <div className='date'>
                            <h6>
                              {shortStatusMap[item.status === "Returned to Source" ? "Returning to Origin" : item.status] 
                                || (item.status === "Returned to Source" ? "Returning to Origin" : item.status)}
                              {clickableStatuses.includes(item.status) &&
                                logsData[item.status]?.data?.length > 0 && (
                                <span
                                  style={{ cursor: "pointer", marginLeft: "6px" }}
                                  onClick={() => {
                                    if (selectedStatus === item.status) {
                                      setSelectedStatus(null);
                                      setShowTable(false);
                                    } else {
                                      setSelectedStatus(item.status);
                                      setShowTable(true);
                                    }
                                  }}
                                >
                                  <Icon icon="material-symbols:info-outline" />
                                </span>
                              )}
                            </h6>
                            <h4>{item?.date}</h4>
                          </div>
                        </div>
                        <div className='date'>
                          <p>{item.time}</p>
                        </div>
                      </div>
                      {showTable && selectedStatus === item.status && (
                        <div className="my-3 table-responsive">
                          <div className='shipment-logs-box'>
                            <p className='fw-500'>
                              {logsData[selectedStatus]?.title}
                            </p>

                            {logsData[selectedStatus]?.data
                              ?.slice()
                              .reverse()
                              ?.map((section, idx) => (
                                <div className='r-sipment-content sipment-content' key={idx}>
                                  {section.logs.slice().reverse().map((log, i) => (
                                    <div className='shipment-log' key={i}>
                                      <p className='fw-500 shipment-log-heading'>{section.date} <span className='log-time'>{log.time}</span></p>
                                      <div className='shipment-log-time'>
                                        <p className='log-remark mb-0 f-14'>{log.remark} <span className='shipment-remark'>{log.location}</span></p>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div className='history-item-n'>
                  {showTable && (
                    <div className="mt-3">
                      <div className='shipment-logs-box'>
                        <p className='fw-500'>
                          {logsData[selectedStatus || getDefaultLogStatus]?.title}
                        </p>
                        {logsData[selectedStatus || getDefaultLogStatus]?.data?.slice().reverse()?.map((section, idx) => (
                          <div className='sipment-content' key={idx}>
                            <p className='fw-500 shipment-log-heading'>{section.date}</p>

                            {section.logs.slice().reverse().map((log, i) => (
                              <div className='shipment-log' key={i}>
                                <div className='shipment-log-time'>
                                  <p className='log-time mb-0'>{log.time}</p>
                                  <p className='log-remark mb-0 f-14'>{log.remark}</p>
                                </div>
                                <div className='shipment-remark'>
                                  <p className='mb-0'>{log.location}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div> 
        {showModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal">

              <div className="modal-header">
                <h5>Child Waybills</h5>
                <button className='border-0 bg-transparent' onClick={() => setShowModal(false)}>✕</button>
              </div>

              <div className="modal-body">
                <ul className='child-waybill'>
                  {shipment?.child_waybill
                    ?.split(",")
                    .filter(Boolean)
                    .map((awb, i) => (
                      <li key={i}>
                        <span>{i + 1}.</span> {awb.trim()}
                      </li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
        )}
      </div>
    </div>
    
  );
}

export default TrackingHistory;